export default "__VITE_ASSET__Cr55DOBW__"